export const memoizeWith = <F extends (...args: any[]) => any>(
  keyGen: (...args: Parameters<F>) => string,
  fn: F,
) => {
  const cache: Record<string, ReturnType<F>> = {};

  return (...args: Parameters<F>) => {
    const key = keyGen(...args);
    if (!cache[key]) {
      cache[key] = fn(...args);
    }
    return cache[key];
  };
};
